import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuctionList, AuctionResponse } from '../../modules/auction/types';
import { ContractDetail, CreateContract } from '../../modules/common/types/types';
import { AuctionRegisterHistoryList, AuctionRegisterHistorySearch, ProductDetailResponse } from '../../modules/profile/types';

const contractApi = createApi({
    reducerPath: 'contractApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/contract",
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        createContract: builder.mutation<ContractDetail, CreateContract>({
            query: (body) => ({
                url: 'create',
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: ContractDetail }, meta, arg) => {
                return response.body;
            },
        }),
        getContractById: builder.query<ContractDetail, number>({
            query: (id) => `detail?contractId=${id}`,
            transformResponse: (response: { body: ContractDetail }, meta, arg) => {
                return response.body;
            },
        }),
        editContract: builder.mutation<ContractDetail, CreateContract>({
            query: (body) => {
                const { contractId, ...submitBody } = body;
                return ({
                    url: `edit/${body.contractId}`,
                    method: 'PUT',
                    body: submitBody,
                })
            },
            transformResponse: (response: { body: ContractDetail }, meta, arg) => {
                return response.body;
            },
        }),
        searchProductRegisterHistory: builder.query<AuctionRegisterHistoryList, AuctionRegisterHistorySearch>({
            query: (body) => {
                const { page, size, keyword, ...rest } = body;
                return ({
                    url: `search-history?page=${page || 0}&size=${size || 10}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
                    method: 'POST',
                    body: rest,
                })
            },
            transformResponse: (response: { body: AuctionRegisterHistoryList }, meta, arg) => {
                return response.body;
            }
        }),
        viewProductDetail: builder.query<ProductDetailResponse, number>({
            query: (id) => `search-history/detail/${id}`,
            transformResponse: (response: { body: ProductDetailResponse }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const {
    useCreateContractMutation,
    useLazyGetContractByIdQuery,
    useEditContractMutation,
    useLazySearchProductRegisterHistoryQuery,
    useLazyViewProductDetailQuery } = contractApi;
export default contractApi;
